import styles from './Unauthorized.module.scss';

export const UnAuthorized = () => {
    return (
        <div className={styles.unauthorizedDiv}>
            <h1>Access to this page is restricted</h1>
            <h5>Please contact either your internal system adminstrator or operational support team for assistance.</h5>
        </div>
    );
};
